// SaveHandlerContext.tsx
import { createContext, ReactNode, useContext, useState } from "react";

type SaveHandlerContextType = {
    hasUnsavedChanges: boolean;
    setHasUnsavedChanges: (value: boolean) => void;
    resetSaveState: () => void;
};

const SaveHandlerContext = createContext<SaveHandlerContextType | null>(null);

type SaveHandlerProviderProps = {
    children: ReactNode;
};

export function SaveHandlerProvider({ children }: SaveHandlerProviderProps) {
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

    const resetSaveState = () => {
        setHasUnsavedChanges(false);
    };

    return (
        <SaveHandlerContext.Provider
            value={{
                hasUnsavedChanges,
                setHasUnsavedChanges,
                resetSaveState,
            }}
        >
            {children}
        </SaveHandlerContext.Provider>
    );
}

export function useSaveHandler() {
    const ctx = useContext(SaveHandlerContext);
    if (!ctx) {
        throw new Error("useSaveHandler must be used inside a SaveHandlerProvider");
    }
    return ctx;
}